const FORM_TEMPLATE_TYPE = {
    regular: 'regular',
    offer: 'offer',
    transition: 'transition',
    application: 'application',
    acceptance: 'acceptance',
    shareable: 'shareable',
    contact: 'contact',
    selfService: 'selfService'
};

export const FORM_TEMPLATE_TYPE_LABELS = {
    regular: 'Regular',
    offer: 'Offer',
    transition: 'Transition',
    application: 'Application',
    acceptance: 'Acceptance',
    shareable: 'Shareable',
    contact: 'Contact',
    selfService: 'Self-service'
};

export default FORM_TEMPLATE_TYPE;
